__turbopack_context__.v({
  "mandatoryBox": "Lrzipa_mandatoryBox",
  "mandatoryHeaderText": "Lrzipa_mandatoryHeaderText",
  "mandatoryText": "Lrzipa_mandatoryText",
});
